import { gql } from "@apollo/client";

/**
 * Question auditors' findings for /admin/audits, grouped by question. See
 * QuestionAudit on the server. Development only.
 */
export const GET_AUDIT_FINDINGS = gql`
  query GetAuditFindings(
    $status: String
    $auditor: String
    $severity: String
    $category: String
    $subject: String
    $grade: Int
    $skill: String
    $pending: Boolean
    $limit: Int
    $offset: Int
  ) {
    auditFindings(
      status: $status
      auditor: $auditor
      severity: $severity
      category: $category
      subject: $subject
      grade: $grade
      skill: $skill
      pending: $pending
      limit: $limit
      offset: $offset
    ) {
      totalQuestions
      totalFindings
      categories
      auditors {
        auditor
        model
        runs
        lastRunAt
        questionsReviewed
        openCritical
        openMajor
        openMinor
        openTotal
      }
      questions {
        filePath
        pending
        skillKey
        skillName
        question
        answer
        alternativeAnswers
        choices
        hint
        reviewedBy
        findings {
          id
          auditor
          model
          severity
          category
          comment
          suggestedFix
          status
          resolutionNote
          createdAt
          resolvedAt
          stale
          missing
        }
      }
    }
  }
`;
